export const buyerStateChartOptions = {
    chart: {
        animation: false,
        type: 'pie',
        height: 300,
        backgroundColor: 'transparent',
    },
    title: {
        text: undefined,
    },
    tooltip: {
        headerFormat: undefined,
        pointFormat: '{point.name}: <b>{point.percentage:.2f}%</b> ({point.y})'
    },
    credits: {
        enabled: false
    },
    legend: {
        alignColumns: false,
        itemStyle: {
            fontWeight: 'normal'
        },
        labelFormat: '{percentage:.2f}% {name}',
        layout: 'horizontal',
    },
    plotOptions: {
        pie: {
            animation: false,
            dataLabels: {
                enabled: false
            },
            showInLegend: true,
        },
    },
    series: [{
        data: []
    }]
};